import { SVG, SVGProps } from './svg'

export function IconTemplate(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M6 2h12a2 2 0 012 2v5a2 2 0 01-2 2H6a2 2 0 01-2-2V4c0-1.1.9-2 2-2zm12 2v5H6V4h12zM6 13h12a2 2 0 012 2v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5c0-1.1.9-2 2-2zm12 7v-5H6v5h12z"
      />
    </SVG>
  )
}
